import { RequestErrorType } from './models/Error';
/**
 * Collection of tools
 */
var Tools = (function () {
    function Tools() {
    }
    /**
     * Checks which kind of error the given error is.
     * @param {HttpErrorResponse} error Error
     * @returns {RequestError} Error with error type (clientside or serverside)
     */
    Tools.checkError = function (error) {
        return {
            type: error.error instanceof Error ? RequestErrorType.CLIENTSIDE : RequestErrorType.SERVERSIDE,
            body: error,
        };
    };
    return Tools;
}());
export { Tools };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/tools.ts.pre-build-optimizer.js